import {
  FieldConfig,
  nString,
  uNumber,
  uString,
  Uuid,
} from '@hidat/huijs-common';

/**
 * Branded Resources
 * We have several entities that have very similar data related to 'branding' information for the resource.
 * This would be imagery, naming, descriptions.
 * This is an attempt to normalize this data so we can have a single set of services and interfaces to deal with it.
 */
export interface ExtendedBrandingInterface {
  colorScheme?: 'dark' | 'light' | undefined | null;
  backgroundColor?: nString;

  backgroundImageUrl?: nString; // Large background image
  bannerImageUrl?: nString; // Long horizontal banner image
  avatarImageUrl?: nString; // Squarish avatar/button image
  thumbnailImageUrl?: nString; // around 100px square image
  rssFeedImageUrl?: nString;

  // Backups for when the object gets synced
  previousImageUrl?: nString;
  previousDescription?: nString;
}

export const ExtendedBrandingFields = [
  new FieldConfig('colorScheme'),
  new FieldConfig('backgroundColor'),
  new FieldConfig('backgroundImageUrl'),
  new FieldConfig('bannerImageUrl'),
  new FieldConfig('avatarImageUrl'),
  new FieldConfig('thumbnailImageUrl'),
  new FieldConfig('rssFeedImageUrl'),
  new FieldConfig('previousDescription').setEditable(false),
  new FieldConfig('previousImageUrl').setEditable(false),
];

export interface BrandedResource<idT extends number | Uuid> {
  id: idT | undefined;
  name: uString;
  tagLine: nString;
  description: nString;
  imageUrl: nString;
  branding: ExtendedBrandingInterface | undefined;
}
